<template>
    <div v-if="enabled" class="demo-banner" data-testid="demo-banner" role="status">
        {{ $t('authFooter.1') }}
    </div>
</template>
<script>
export default {
    emits: ['change'],
    data() { return { enabled: false }; },
    async mounted() {
        try {
            const response = await fetch('/runtime-environment.json', {
                cache: 'no-store', headers: { Accept: 'application/json' },
            });
            if (response.ok) {
                const config = await response.json();
                this.enabled = config?.testEnvironmentNotice?.enabled === true;
            }
        } catch (_) {
            // Missing or malformed runtime data must not label production as demo.
        }
        this.$emit('change', this.enabled);
    },
};
</script>
<style scoped>
.demo-banner {
    position: sticky;
    top: 0;
    z-index: 100;
    width: 100%;
    padding: 12px 20px;
    background: #fff3cd;
    color: #513c00;
    border-bottom: 1px solid #dfc577;
    font-size: 14px;
    line-height: 1.5;
    text-align: center;
    overflow-wrap: anywhere;
}
</style>
